function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, storage, tracking) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-gdpr-settings-privacy': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-table-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'gdpr-settings-privacy-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'gdpr-settings-privacy-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Personalize your Mixpanel experience");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Mixpanel uses cookies to deliver a personalized experience for our users. Storing this information allows us");
              __jade_nodes = __jade_nodes.concat("  to keep you logged in to Mixpanel, and returns you to where you were when you last left the site, along with");
              __jade_nodes = __jade_nodes.concat("  additional benefits.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-switch", {
            "attrs": {
              on: storage
            },
            "on": {
              change: () => $helpers.toggle(`storage`)
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-table-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'gdpr-settings-privacy-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'gdpr-settings-privacy-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Help Mixpanel improve");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Understanding how our customers use Mixpanel is how we improve our products & services. Help us make Mixpanel");
              __jade_nodes = __jade_nodes.concat("  better by allowing us to log your product usage.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-switch", {
            "attrs": {
              on: tracking
            },
            "on": {
              change: () => $helpers.toggle(`tracking`)
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "storage" in locals ? locals.storage : typeof storage !== "undefined" ? storage : undefined, "tracking" in locals ? locals.tracking : typeof tracking !== "undefined" ? tracking : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;